import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const PLATFORMS = [
  { key: 'web', label: 'Web', color: '#6366f1' },
  { key: 'ios', label: 'iOS', color: '#10b981' },
  { key: 'android', label: 'Android', color: '#f59e0b' },
];

const PlatformUsageChart = ({ title = 'Users by Platform', data, loading }) => {
  if (loading) {
    return (
      <div className="bi-chart-card">
        <h3 className="bi-chart-title">{title}</h3>
        <div className="bi-chart-skeleton" style={{ height: 240 }} />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="bi-chart-card">
        <h3 className="bi-chart-title">{title}</h3>
        <div className="bi-chart-empty" style={{ height: 200 }}>No data available</div>
      </div>
    );
  }

  // Yesterday's values for legend counts (second-to-last since today is incomplete)
  const yesterday = data.length >= 2 ? data[data.length - 2] : data[data.length - 1];

  return (
    <div className="bi-chart-card">
      <h3 className="bi-chart-title">{title}</h3>
      <ResponsiveContainer width="100%" height={240}>
        <AreaChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--admin-gray-200)" />
          <XAxis dataKey="date" tick={{ fontSize: 11 }} stroke="var(--admin-gray-400)" />
          <YAxis tick={{ fontSize: 11 }} stroke="var(--admin-gray-400)" />
          <Tooltip
            contentStyle={{
              background: 'white',
              border: '1px solid var(--admin-gray-200)',
              borderRadius: '8px',
              fontSize: '12px',
            }}
          />
          {PLATFORMS.map((p) => (
            <Area
              key={p.key}
              type="monotone"
              dataKey={p.key}
              name={p.label}
              stackId="1"
              stroke={p.color}
              fill={p.color}
              fillOpacity={0.6}
            />
          ))}
        </AreaChart>
      </ResponsiveContainer>
      <div className="bi-platform-legend">
        {PLATFORMS.map((p) => (
          <div key={p.key} className="bi-platform-legend-item">
            <span className="bi-platform-legend-dot" style={{ backgroundColor: p.color }} />
            <span className="bi-platform-legend-label">{p.label}</span>
            <span className="bi-platform-legend-count">
              {(yesterday?.[p.key] ?? 0).toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlatformUsageChart;
